export default theme => ({
  content: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(3),
    border: `1px solid ${theme.palette.border}`
  },
  tourMap: {
    minWidth: '100%',
    minHeight: 'calc(-195px + 100vh)',
    border: '1px solid lightgrey',
    borderRadius: '3px',
  },
  navButton: {
    marginRight: theme.spacing(1)
  },
  marginTop: {
    marginTop: theme.spacing(2)
  },
});
